module.exports = __webpack_public_path__ + "img/lv1.4c4078bd.png";